import PlayerManager from "../../../service/player-manager";
import SocketService from "../../../service/socket";
import ToastService from "../../../service/toast-service";
import PlaylistService from "../../../service/playlist-service";

const isInRoom = () => {
  const roomState = SocketService.getState();
  const { isJoined: isInRoom } = roomState;
  return isInRoom;
};

const playAll = (songs) => {
  if (isInRoom()) return ToastService.errorToast("Cannot play while in room!");
  if (songs && songs.length > 0) PlayerManager.playAll(songs);
  else ToastService.infoToast("cannot play empty playlist");
};

const addToQueue = async ({ songs, playlistId }) => {
  if (isInRoom())
    return ToastService.errorToast(
      "Changes to queue can only be applied through room."
    );
  if (songs) {
    PlayerManager.addToQueue(songs);
  } else {
    const playlist = await PlaylistService.getPlaylist({
      id: playlistId,
    });
    PlayerManager.addToQueue(playlist.songs);
  }
  ToastService.infoToast("queue modified");
};

const playSong = ({ queue, idx }) => {
  if (isInRoom()) return ToastService.errorToast("Cannot play while in room!");
  PlayerManager.playAll(queue, idx);
};

const changePlaylistTheme = async ({ id, song }) => {
  const { thumbnails } = song;
  const thumbnail =
    thumbnails && (thumbnails.mediumUrl || thumbnails.standardUrl);
  if (!thumbnail) return false;
  const done = await PlaylistService.editPlaylist({
    id,
    thumbnail,
  });
  return done;
};

export { playAll, addToQueue, playSong, changePlaylistTheme };
